import axios from 'axios';

export default {
    users  : {
        login: (credentials) => axios.post("/api/login", {...credentials}).then(res => res.data),
        get: () => axios.get('/api/users').then(res => res.data),
        add: (data) => axios.post('/api/users', data).then(res => res.data),
        update: (id, data) => axios.post(`/api/users/${id}`, data).then(res => res.data),
        delete: (id) => axios.delete(`/api/users/${id}`).then(res => res.data),
        refreshPermissions: (id) => axios.get(`/api/users/${id}/refresh`).then(res => res.data),
    },
    places : {
        get: () => axios.get("/api/web/places").then(res => res.data),
        getPlace: (id) => axios.get(`/api/web/places/${id}`).then(res => res.data),
        add: (data) => axios.post("/api/places", data).then(res => res.data),
        delete: (placeId) => axios.delete(`/api/places/${placeId}`).then(res => res.data),
        getAnalytics: (placeId, query) => axios.get(`/api/place/${placeId}/analytics`, {params: query}).then(res => res.data),
        update: (data) => axios.put("/api/places", data).then(res => res.data),
        getTargetsByPlace: (placeId) => axios.get(`/api/web/places/${placeId}/poi`).then(res => res.data),        
    },
    config : {
        get   : () => axios.get("/api/config").then(res => res.data),
        update: (config) => axios.post("/api/config", {...config}).then(res => res.data),
    },
    targets: {
        get: () => axios.get("/api/poi").then(res => res.data),
        getTarget: (id) => axios.get(`/api/poi/${id}`).then(res => res.data),
        add: (data) => axios.post("/api/poi", data).then(res => res.data),
        delete: (placeId) => axios.delete(`/api/poi/${placeId}`).then(res => res.data),
        getAnalytics: (targetId, query) => axios.get(`/api/poi/${targetId}/analytics`, {params: query}).then(res => res.data),
        update: (data) => axios.put("/api/poi", data).then(res => res.data),
    },
    files  : {
        upload: (formData) => axios.post("/api/files", formData).then(res => res.data),
        get: () => axios.get('/api/files').then(res => res.data),
        search: (query) => axios.get('/api/files/search', {params: query}).then(res => res.data),
        delete: (id) => axios.delete(`/api/files/${id}`).then(res => res.data),
    },
    notifications: {
        send: (data) => axios.post("/api/notifications", data).then(res => res.data)
    },
    analytics: {
        home: (query) => axios.get("/api/analytics", { params: query }).then(res => res.data),
        featured: (query) => axios.get("/api/analytics/featured", { params: query }).then(res => res.data),
        featuredLocation: (id, query) => axios.get(`/api/analytics/featured/${id}/location`, { params: query }).then(res => res.data),
    },
    city : {
        add: (data) => axios.post("/api/city", data).then(res => res.data),
        get: (data) => axios.get("/api/city").then(res => res.data),
        update: (data) => axios.put("/api/city", data).then(res => res.data),
        delete: (id) => axios.delete(`/api/city/${id}`).then(res => res.data),
    },
    category: {
        search: (data) => axios.post("/api/category/search", data).then(res => res.data),
        add: (data) => axios.post("/api/category", data).then(res => res.data),
        get: (data) => axios.get("/api/web/category").then(res => res.data),
        delete: (id) => axios.delete(`/api/web/category/${id}`).then(res => res.data),
        update: (id, data) => axios.put(`/api/web/category/${id}`, data).then(res => res.data),
    }
}


// WEBPACK FOOTER //
// ./src/api.js